(function () {
	const hoverToggle = () => {
		const tabs = document.querySelectorAll(".image-tabs__list a");
		const tabItems = document.querySelectorAll(".image-tabs__list li");
		
		// Prevent default link behavior
		tabs.forEach(function(tab) {
			tab.addEventListener("click", function(e) {
				e.preventDefault();
			});
		});
		
		// Handle tab hover
		tabItems.forEach(function(tabItem) {
			tabItem.addEventListener("mouseover", function() {
				if (this.classList.contains("active")) {
					return;
				}
				
				// Remove active class from all tabs
				tabItems.forEach(function(item) {
					item.classList.remove("active");
				});
				
				// Add active class to current tab
				this.classList.add("active");
				
				// Get the href from the current tab
				const link = this.querySelector("a");
				const id = link ? link.getAttribute("href") : "";
				
				// Hide all content sections
				const contentSections = document.querySelectorAll(".image-tabs__desc, .image-tabs__button-wrraper, .image-tabs__img");
				contentSections.forEach(function(section) {
					section.style.display = "none";
				});
				
				// Show the targeted content
				const targetSections = document.querySelectorAll(`[data-image-tabs="${id}"]`);
				targetSections.forEach(function(section) {
					section.style.display = "block";
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		hoverToggle();
	});

	hoverToggle();
})();
